import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import swal from 'sweetalert2';

@Injectable()
export class MessageErrorInterceptor implements HttpInterceptor {
    constructor(public _router: Router) { }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {

        const SKIP_URL_API = ['ValidatePersonalData'];
        const urlApi = request.url.split('/').reverse()[0];

        return next.handle(request).pipe(
            tap(
                event => {
                    if (event instanceof HttpResponse && event.ok) {
                        if (event.body.valid !== undefined && !event.body.valid) {
                            if (event.body.message != null && event.body.message != undefined) {
                                if (event.body.intercept) {
                                    if (event.body.warning) {
                                        swal.fire({
                                            title: 'Información',
                                            text: event.body.message,
                                            icon: 'warning'
                                        })
                                    } else {
                                        if (SKIP_URL_API.includes(urlApi)) {
                                            console.log(event.body)
                                            swal.fire("", event.body.message, "error").then((result: any) => {

                                                if (result.value) {
                                                    const codeError = event.body.codeError;
                                                    if (codeError == 2) {
                                                        // Aquí puedes realizar la acción que deseas después de hacer clic en "OK"
                                                        this._router.navigate(['/ofivirtual']);

                                                    }
                                                }
                                            });
                                        } else {

                                            swal.fire({
                                                title: event.body.message,
                                                icon: 'error',
                                                toast: true,
                                                position: 'top-end',
                                                showConfirmButton: false,
                                                timer: 5000
                                            });

                                        }

                                    }
                                }
                            } else {
                                swal.fire({
                                    title: "Ha ocurrido un error inesperado.",
                                    icon: 'error',
                                    toast: true,
                                    position: 'top-end',
                                    showConfirmButton: false,
                                    timer: 5000
                                });

                            }
                        }
                    }
                },
                (error: HttpErrorResponse) => { }
            )
        );
    }
}